"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactDom = require("react-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _AnchoredOverlay = require("web/shared/components/AnchoredOverlay.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* An overlay drawn into the document body, positioned against the element
* that opened it.
*
* An overlay laid out inside its trigger is at the mercy of every ancestor
* between it and the page: one `overflow` anywhere in that chain crops it,
* and a scrolling region is exactly where anchored overlays are most needed.
* Out here nothing can clip it, and where it sits is arithmetic on the
* trigger's own viewport position.
*
* It is placed once, when it opens. Nothing re-measures it while it is up:
* the caller is told to dismiss it on anything that would move the trigger,
* which is the honest answer for an overlay that is not pinned to what it
* points at — a stale overlay chasing its anchor a frame late reads worse
* than one that closes.
*
* Positioned by the viewport, so `position: fixed`. Stacking is app-level
* because the overlay is no longer inside the stacking context it came from.
*/ // The gap between the trigger and the overlay, and how close to the window's
// edge the overlay may get.
const GAP = 6;
const EDGE_MARGIN = 8; // Which side of the trigger the overlay sits on: named, or "auto" for
// below when the overlay fits below the trigger and above when it does
// not — what a trigger near either edge of the screen needs.
// Where the overlay goes: on the asked-for side of the trigger, centered on
// it, and pulled back from whichever window edge it would otherwise cross —
// an overlay on the last column would open off the right of the screen, and
// one on the top row would open above the top of it.
function placeAgainst(trigger, overlay, placement) {
  const rect = trigger.getBoundingClientRect();
  const width = overlay.offsetWidth;
  const height = overlay.offsetHeight;
  const fitsBelow = rect.bottom + GAP + height + EDGE_MARGIN <= window.innerHeight;
  const above = placement === "above" || placement === "auto" && !fitsBelow;
  const top = above ? rect.top - height - GAP : rect.bottom + GAP;
  const centered = rect.left + rect.width / 2 - width / 2;
  return {
    top: Math.max(EDGE_MARGIN, Math.min(top, window.innerHeight - height - EDGE_MARGIN)),
    left: Math.max(EDGE_MARGIN, Math.min(centered, window.innerWidth - width - EDGE_MARGIN))
  };
}
function AnchoredOverlay(props) {
  const _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    overlay = _useState2[0],
    setOverlay = _useState2[1];
  const _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    at = _useState4[0],
    setAt = _useState4[1];
  const anchor = props.anchor,
    placement = props.placement,
    onDismiss = props.onDismiss; // A callback ref rather than a useRef, because the position depends on the
  // overlay's own measured size: this runs the moment the element exists,
  // where a ref object would still be null on the first pass.
  const holdOverlay = (0, _react.useCallback)(element => {
    setOverlay(element);
  }, []); // Measured after the overlay exists but before it is painted, so it is
  // never seen at the wrong place first.
  (0, _react.useLayoutEffect)(() => {
    if (anchor == null || overlay == null) {
      setAt(null);
      return;
    }
    setAt(placeAgainst(anchor, overlay, placement));
  }, [anchor, overlay, placement]);
  (0, _react.useEffect)(() => {
    if (anchor == null || onDismiss == null) {
      return undefined;
    } // Capture, so a scroll inside any container on the way up reaches this
    // and not only a scroll of the window itself.
    window.addEventListener("scroll", onDismiss, true);
    window.addEventListener("resize", onDismiss);
    return () => {
      window.removeEventListener("scroll", onDismiss, true);
      window.removeEventListener("resize", onDismiss);
    };
  }, [anchor, onDismiss]);
  if (anchor == null) {
    return null;
  }
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
    ref: holdOverlay,
    role: props.role,
    "aria-label": props.label,
    "data-column-filter": props.dataColumnFilter === true ? "" : undefined
  }, stylex.props(_AnchoredOverlay.styles.overlay)), {}, {
    // Hidden until it has been measured, rather than drawn at the window's
    // top-left corner for one frame.
    style: at == null ? {
      visibility: "hidden"
    } : at,
    children: props.children
  })), document.body);
}
var _default = exports.default = AnchoredOverlay;